import ADD_PLATFORM from "./addPlatform"
import GENERATE_BLOG_ROUNDUP from "./generateBlogRoundup"

export default {
  ADD_PLATFORM,
  GENERATE_BLOG_ROUNDUP
}
